import { AfterContentInit, Component, HostBinding, Input, OnDestroy } from "@angular/core";
import { ImmutableRedux } from "../../redux/immutable-redux.service";

import { CommonFormManagerDirective } from "./form-manager.directive";
import { commonFormReducerFactory } from "./reducer";

@Component({
    selector: "common-form",
    templateUrl: "./common-form.component.html",
    providers: [CommonFormManagerDirective],
})
export class CommonFormComponent implements AfterContentInit, OnDestroy {
    @HostBinding("class") public classes = "u-flex-col u-hex-width-full";
    @Input() public stateProp: string;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        private formManager: CommonFormManagerDirective,
    ) { }

    public ngAfterContentInit(): void {
        this.ngRedux.registerComponent(commonFormReducerFactory, this.rootProp, this.stateProp, this.formManager.state);
    }

    public ngOnDestroy(): void {
        this.ngRedux.unregisterComponent(this.rootProp, this.stateProp);
    }

    public postIsSuccessful() {
        return this.messageOverride === "Success!";
    }

    public get messageOverride(): string | undefined {
        if (this.formManager.formState && this.formManager.formState.formValidation) {
            const message = this.formManager.formState.formValidation.mutationMessage.message;
            return (message === "Success!") ? undefined : message;
        } else {
            return undefined;
        }
    }

    public get rootProp(): string {
        return this.formManager.rootProp;
    }
}
